// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuTitles_wrapper__CJ2Qn"};